import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import API, { graphqlOperation } from "@aws-amplify/api";
import * as queries from "../graphql/queries";
import * as mutations from "../graphql/mutations";

import { makeStyles } from "@material-ui/core/styles";
import { Tabs, Tab } from "@material-ui/core";

// コンテナ
import UserInfo from "../developer/UserInfo";
import Profile from "../developer/Profile";
import UserOrder from "../developer/UserOrder";
import Color from "../developer/Color";
import Category from "../developer/Category";
import { UserBuyma, UserBuymaCreate } from "../developer/UserBuyma";
import { UserShop, UserShopCreate } from "../developer/UserShop";
import { Shop, ShopCreate } from "../developer/Shop";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    marginBottom: "40px",
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
  },
}));

export default function Developer(props) {
  const classes = useStyles();
  const history = useHistory();
  const userGroup = props.userGroup;
  const allShops = props.allShops;

  const [value, setValue] = useState("userInfo");
  const [userInfos, setUserInfos] = useState([]);
  const [userOrders, setUserOrders] = useState([]);
  const [userBuymas, setUserBuymas] = useState([]);
  const [userShops, setUserShops] = useState([]);
  const [userProfiles, setUserProfiles] = useState([]);

  useEffect(() => {
    // 管理者のみ
    if (!userGroup.includes("default")) {
      if (!userGroup.includes("Administrator")) {
        history.push("/");
        return;
      } else if (userInfos.length === 0) {
        API.graphql(
          graphqlOperation(queries.listUserInfos, {
            limit: 500,
          })
        )
          .then((res) => {
            setUserInfos(res.data.listUserInfos.items);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
  }, [userGroup]);

  useEffect(() => {
    if (userInfos.length !== 0) {
      console.log(userInfos);
      // ユーザープロフィール
      setUserProfiles(userInfos.map((data) => data.profile));

      // ユーザーBUYMA
      let userBuymaLists = [];
      userInfos.forEach((res) => {
        res.buyma.items.forEach((data) => {
          // プロフィール
          data["email"] = res.email;
          data["name"] = res.profile.name;
          userBuymaLists.push(data);
        });
      });
      setUserBuymas(userBuymaLists);

      let userOrderLists = [];
      userInfos.forEach((res) => {
        res.order.items.forEach((data) => {
          let metadata = data.metadata;
          metadata = JSON.parse(metadata);
          data["link"] = metadata.link;
          // プロフィール
          data["email"] = res.email;
          data["name"] = res.profile.name;
          userOrderLists.push(data);
        });
      });
      console.log(userOrderLists);
      setUserOrders(userOrderLists);

      // ユーザーSHOP
      let userShopLists = [];
      userInfos.forEach((res) => {
        res.shop.items.forEach((data) => {
          // プロフィール
          data["email"] = res.email;
          data["name"] = res.profile.name;
          userShopLists.push(data);
        });
      });
      setUserShops(userShopLists);
    }
  }, [userInfos]);

  // Graphqlレコード更新処理
  const handleUpdateGraphql = (mutation, e) => {
    e.preventDefault();
    let value = e.target[0].value;
    if (e.target[0].type === "number") {
      value = Number(value);
    }
    let input = {
      id: e.target[0].name,
    };
    input[e.target.innerText] = value;
    API.graphql({
      query: mutations[mutation],
      variables: { input: input },
    })
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Graphqlレコード登録処理
  const handleDeleteGraphql = (mutation, id) => {
    var input = {
      id: id,
    };
    API.graphql({
      query: mutations[mutation],
      variables: { input: input },
    })
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Graphqlレコード登録処理
  const handleCreateGraphql = (mutation, input) => {
    console.log(input);
    API.graphql({
      query: mutations[mutation],
      variables: { input: input },
    })
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  function GqlList(props) {
    if (props.value === "userInfo") {
      return (
        <UserInfo
          userInfos={userInfos}
          handleUpdateGraphql={handleUpdateGraphql}
          handleDeleteGraphql={handleDeleteGraphql}
        />
      );
    } else if (props.value === "profile") {
      return (
        <Profile
          userProfiles={userProfiles}
          handleDeleteGraphql={handleDeleteGraphql}
          handleUpdateGraphql={handleUpdateGraphql}
        />
      );
    } else if (props.value === "userBuyma") {
      return (
        <UserBuyma
          userBuymas={userBuymas}
          handleDeleteGraphql={handleDeleteGraphql}
          handleUpdateGraphql={handleUpdateGraphql}
        />
      );
    } else if (props.value === "userOrder") {
      return (
        <UserOrder
          userOrders={userOrders}
          handleDeleteGraphql={handleDeleteGraphql}
          handleUpdateGraphql={handleUpdateGraphql}
        />
      );
    } else if (props.value === "userShop") {
      return (
        <UserShop
          allShops={allShops}
          userShops={userShops}
          handleDeleteGraphql={handleDeleteGraphql}
          handleUpdateGraphql={handleUpdateGraphql}
        />
      );
    } else if (props.value === "shop") {
      return (
        <Shop
          allShops={allShops}
          userInfos={userInfos}
          handleDeleteGraphql={handleDeleteGraphql}
          handleUpdateGraphql={handleUpdateGraphql}
        />
      );
    } else if (props.value === "color") {
      return (
        <Color
          handleUpdateGraphql={handleUpdateGraphql}
          handleDeleteGraphql={handleDeleteGraphql}
        />
      );
    } else if (props.value === "category") {
      return (
        <Category
          handleUpdateGraphql={handleUpdateGraphql}
          handleDeleteGraphql={handleDeleteGraphql}
        />
      );
    } else {
      return <div>{props.value}</div>;
    }
  }

  function CreateForm(props) {
    if (props.value === "userBuyma") {
      return (
        <UserBuymaCreate
          userInfos={userInfos}
          userBuymas={userBuymas}
          handleCreateGraphql={handleCreateGraphql}
        />
      );
    } else if (props.value === "userShop") {
      return (
        <UserShopCreate
          allShops={allShops}
          userInfos={userInfos}
          userShops={userShops}
          handleCreateGraphql={handleCreateGraphql}
        />
      );
    } else if (props.value === "shop") {
      return (
        <ShopCreate
          allShops={allShops}
          userInfos={userInfos}
          handleCreateGraphql={handleCreateGraphql}
        />
      );
    } else {
      return <></>;
    }
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <React.Fragment>
      <div className={classes.root}>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="secondary"
          orientation="vertical"
          variant="scrollable"
          scrollButtons="on"
          className={classes.tabs}
        >
          <Tab value="userInfo" label="ユーザー情報" />
          <Tab value="profile" label="プロフィール" />
          <Tab value="userBuyma" label="BUYMAアカウント" />
          <Tab value="userOrder" label="決済情報" />
          <Tab value="userShop" label="ユーザーSHOP" />
          <Tab value="shop" label="ショップ" />
          <Tab value="color" label="カラー" />
          <Tab value="category" label="カテゴリ" />
        </Tabs>
        <GqlList value={value} />
      </div>
      <div className={classes.root}>
        <CreateForm value={value} />
      </div>
    </React.Fragment>
  );
}
